import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AuthModalService {
	// 1 = Login, 2 = Reset Password, 5 = Register
	isOpen = signal(false);
	mode = signal<1 | 2 | 5>(1);

	openLogin(): void {
		this.mode.set(1);
		this.isOpen.set(true);
	}

	openRegister(): void {
		this.mode.set(5);
		this.isOpen.set(true);
	}

	openResetPassword(): void {
		this.mode.set(2);
		this.isOpen.set(true);
	}

	close(): void {
		this.isOpen.set(false);
	}
}
